export default __webpack_public_path__ + "static/media/work_portfolio_top.db94be26.jpg";